import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { sendWebViewMsg } from 'utils/bridge';
import server from 'server/serverController2';
import constants from 'utils/constants';
import useInterval from 'hooks/common/useInterval'; 
import CenterModal from 'components/presenters/modal/CenterModal';
import AnimatedWindow from 'components/containers/common/AnimatedWindow';
import AnimatedWindowHeader from 'components/presenters/header/AnimatedWindowHeader';
import ImgCropperModal from 'components/containers/task/ImgCropperModal';
import Presenter from 'components/presenters/share/SocialShareModal';
import ImageMergeProcessor from 'components/containers/common/ImageMergeProcessor';
import TaskResultTimeStamp from 'components/containers/task/TaskResultTimeStamp';
import { useSelector } from 'react-redux';
import _uniqueId from 'lodash/uniqueId'

import { blobToBase64, getBase64FromUrl } from 'utils/utils.js'; 
export default function SocialShareModal({ visible, shareImg, taskNo , campaignNo, guideTitle, guideMsg,
                                            isImgCancelable = false,// 
                                            onClose, onShare, onFileSelect
                                            
                                        }) {
    const userInfo = useSelector((state) => {
        return state.userInfo;
    });
    const [inputFileId] = useState(_uniqueId('social-share-file-input-'));

    const fileInputRef = useRef(null);
    const [base64ShareImg, setBase64ShareImg] = useState(null);

    //crop modal state
    const [initUploadState, setInitUploadState] = useState(false);
    const [userInputFile, setUserInputFile] = useState(null);
    const [showCropModal ,setShowCropModal] = useState(false);
    const [croppedImg, setCroppedImg] = useState(null);

    //merge image state
    const [base64TemplateImg, setBase64TemplateImg] = useState(null);
    const [mergeFileList, setMergeFileList] = useState([]);  
    const [isImgLoading, setIsImgLoading] = useState(false);

    const [initData, setInitData] = useState(null);
    const [username, setUsername] = useState('');
    const [textCopied, setTextCopied] = useState(false);
    const [valid, setValid] = useState(false);
    const [shareTriggered, setShareTriggered] = useState(false);
    const [showCopiedMsg, setShowCopiedMsg]= useState(false);
    const copyMsgDuration = 2000;// ms

    //Center Modal State
    const [initCenterModal, setInitCenterModal] = useState(false);
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState({});
    const [onModalComplete, setOnModalComplete] = useState(null);
    const [onModalCancel, setOnModalCancel] = useState(null);
    const [sampleImg, setSampleImg] = useState(null);
    //Init Center Modal State
    useEffect(()=>{
        if(initCenterModal === true)
        {
            setCenterModalVisible(false);
            setCenterModalDataList({})
            setOnModalComplete(null);
            setOnModalCancel(null);
            setInitCenterModal(false);
        }
    }, [initCenterModal])

    useEffect(()=>{
        setBase64ShareImg(shareImg);
    },[shareImg])

    useEffect(()=>{
        const generateMergeFileList = async () => { 
            const fileList = [];  
            //Important : Order matters. First Arr Item gets lowest z-index for image merge.
            if(croppedImg)
            {   
                const croppedBase64Img = await blobToBase64(croppedImg)
                fileList.push(croppedBase64Img)
            }
            if(base64TemplateImg)
            { 
                fileList.push(base64TemplateImg)
            }
            setMergeFileList(fileList) 
        }
        generateMergeFileList();
    },[base64TemplateImg, croppedImg])

    useEffect(()=>{
        if(initUploadState === true)
        {
            fileInputRef.current.value=null;
            setUserInputFile(null); 
            setInitUploadState(false);
            setShowCropModal(false);
            setCroppedImg(null);
        }

    },[initUploadState])


    //copy msg animation duration
    useInterval(()=>{
        if(showCopiedMsg === true)
        {
            setShowCopiedMsg(false); 
        }
    },copyMsgDuration)

    //validation check for social share
    useEffect(()=>{
        if(username && base64ShareImg && textCopied === true)
        {
            setValid(true);
        }
        else
        {
            setValid(false);
        }
    },[username, base64ShareImg, textCopied])
 
    //load initial data for social share
    useEffect(() => {
        if(taskNo && visible)
        {
            server.getRequestData(`tasks/${taskNo}/social/share/init`, (res) => {
                try
                {
                    if(res.success !== 1)
                    { 
                        return;
                    }
                    const jsonData = res.data;
                    const socialShareInfo = jsonData['init_data']; 
                    if(socialShareInfo['instagram_username'])
                    {
                        setUsername(socialShareInfo['instagram_username']);
                    }
                    setInitData(socialShareInfo);
                }
                catch(err)
                {
                    console.log(err);
                }  
            });
        }
        else if(campaignNo && visible)
        {
            server.getRequestData(`campaigns/${campaignNo}/social/share/init`, async (res) => {
                try
                {
                    if(res.success !== 1)
                    { 
                        return;
                    }
                    const jsonData = res.data;
                    const socialShareInfo = jsonData['init_data'];
                    // setBase64ShareImg(null);

                    if(socialShareInfo['instagram_username'])
                    {
                        setUsername(socialShareInfo['instagram_username']);
                    }
                    if(socialShareInfo?.sample_img)
                    {
                        setSampleImg(`${constants['imagePath']}/social/sample_img/${socialShareInfo?.sample_img}`)
                    }
                    if(socialShareInfo?.base_img)
                    {
                        let base64ShareImg = await getBase64FromUrl(`${constants['imagePath']}/social/base_img/${socialShareInfo?.base_img}`)
                        setBase64ShareImg(base64ShareImg)
                    }
                    if(socialShareInfo?.template_img)
                    {
                        let base64TemplateFile = await getBase64FromUrl(`${constants['imagePath']}/task_template_img/${socialShareInfo?.template_img}`)
                        setBase64TemplateImg(base64TemplateFile)
                    }
                    setInitData(socialShareInfo);
                }
                catch(err)
                {
                    console.log(err);
                }  
            });
        }
    }, [taskNo, campaignNo, visible]) 

    const selectImg=()=>{  
        fileInputRef.current.click();
    }
    const copyTag = (tag) => { 
        let tmpTextarea = document.createElement('textarea');
        tmpTextarea.value = tag; 
        document.body.appendChild(tmpTextarea);
        tmpTextarea.select();
        tmpTextarea.setSelectionRange(0, tag.length); 
        document.execCommand('copy');
        document.body.removeChild(tmpTextarea);
        setTextCopied(true);
        setShowCopiedMsg(true);
    }
    const saveInstagramUsername = () => {
        const userNo = userInfo['id'];

        const body = {
            instagram_username: username
        }

        server.putRequestData(`users/${userNo}`,  JSON.stringify(body), (res) => {
            try
            {
                if(res.success !== 1)
                {
                    return;
                }
                
            }
            catch(err)
            {
                console.log(err);
            }  
        });
    }
    const handleShare = async () => {
        if(!username)
        {
            setCenterModalVisible(true);
            setCenterModalDataList({description:"인스타 계정 아이디를 입력하셔야\n인증 확인이 가능해요!"});
            setOnModalComplete(()=>()=>{
                setInitCenterModal(true);
            })
            return;
        }
        if(!textCopied)
        {
            setCenterModalVisible(true);
            setCenterModalDataList({description:"필수 해시태그는 복사 하셨나요?\n잊지 말고 복사해서 붙여넣기 해주세요!"});
            setOnModalComplete(()=>()=>{
                setInitCenterModal(true);
            })
            return;
        }
        if(!base64ShareImg)
        {
            setCenterModalVisible(true);
            setCenterModalDataList({description:"공유할 이미지가 지정되지 않았어요."});
            setOnModalComplete(()=>()=>{
                setInitCenterModal(true);
            })
            return;
        }
        try
        {
            saveInstagramUsername();
            await sendWebViewMsg({
                action: 'REQ_INSTAGRAM_SHARE', 
                data: {
                    share_options: {
                        url: base64ShareImg,
                        type: 'image/*',
                        forceDialog: false
                    }
                }
            }).catch((err)=>{
                console.log('err from msg')
                console.log(err)
            });
            setShareTriggered(true);
            if(onShare)
            {
                onShare(`${base64ShareImg}`, username);
            }
        }
        catch(err)
        {
            console.log(err)
            setShareTriggered(true);
            if(onShare)
            {
                onShare(`${base64ShareImg}`, username);
            }
        }
    }
    
    return (
        <div>
            <AnimatedWindow windowOn={visible} zIndex={600}>
                <AnimatedWindowHeader   
                    isCloseBtn={true}
                    onBackBtn={()=>{ 
                        if(onClose)
                        {
                            setInitUploadState(true);
                            onClose(shareTriggered);
                        }
                    }} 
                    
                /> 
                <Presenter 
                    initData={initData} 
                    base64ShareImg={base64ShareImg}
                    sampleImg={sampleImg}
                    valid={valid}
                    isImgLoading={isImgLoading}
                    isImgCancelable={isImgCancelable}
                    username={username}
                    guideTitle={(guideTitle)?guideTitle :((initData?.guide_title)? initData.guide_title:null)}
                    guideMsg={(guideMsg)?guideMsg :((initData?.guide_msg)? initData.guide_msg:null)}
                    showCopiedMsg={showCopiedMsg}
                    onCopyTag={(tag)=>{copyTag(tag)}}
                    onChangeUsername={(username)=>{setUsername(username)}}
                    onClickResetUsername={()=>{setUsername('')}}
                    onClickShareBtn={handleShare}
                    onClickFileSelect={()=>{
                        selectImg()
                    }}
                    onCancelImg={()=>{
                        setInitUploadState(true);
                        setBase64ShareImg(null);
                    }}
                />
                <CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
                <ImgFileInput 
                    id={inputFileId}
                    type="file" 
                    accept="image/*" 
                    ref={fileInputRef} 
                    onChange={async (e)=>{ 
                        if (e.target.files && e.target.files.length > 0) {
                            let targetImg = e.target.files[0]; 
                            setUserInputFile(targetImg)
                            setShowCropModal(true);
                        }  
                    }}  
                />
                <ImgCropperModal 

                    visible={showCropModal} 
                    srcImg={userInputFile} 
                    croppedImg={croppedImg}
                    setCroppedImg={setCroppedImg} 
                    onCancel={(e)=>{
                        setInitUploadState(true);
                    }}
                    onComplete={(e)=>{ 
                        setShowCropModal(false);
                        fileInputRef.current.value=null;
                        setUserInputFile(null); 
                    }}
                    onError={(error)=>{
                        if(error['detail_code'] === 'IMG_NOT_LOADED')
                        {
                                setInitUploadState(true);
                                setCenterModalVisible(true);
                                setCenterModalDataList({description:"이미지 로드를 실패했어요.\n 다시 시도해주세요."});
                                setOnModalComplete(()=>()=>{
                                    setInitCenterModal(true);
                                })
                        }
                        else
                        {
                            setInitUploadState(true);
                            setCenterModalVisible(true);
                            setCenterModalDataList({description:"이미지 등록을 실패했어요.\n 다시 시도해주세요."});
                            setOnModalComplete(()=>()=>{
                                setInitCenterModal(true);
                            })
                        }
                    }}
                />
                {(croppedImg && base64TemplateImg && mergeFileList.length > 1 && (
                    <ImageMergeProcessor 
                        base64Images={mergeFileList}//mergeFileList
                        domTemplate={[<TaskResultTimeStamp key={'task-result-timestamp'} />
                        ]}
                        onComplete={(mergedImg)=>{
                            console.log(mergedImg);
                            setBase64ShareImg(mergedImg);
                            setIsImgLoading(false);
                            setInitUploadState(true);
                        }}
                        onProcessing={()=>{
                            //onMerge
                            setIsImgLoading(true);
                        }}
                        onError={()=>{
                            setInitUploadState(true);
                            setCenterModalVisible(true);
                            setCenterModalDataList({description:"이미지 로드를 실패했어요.\n 다시 시도해주세요."});
                            setOnModalComplete(()=>()=>{
                                setInitCenterModal(true);
                            })
                        }}
                    />
                ))}
            </AnimatedWindow>
        </div>
    )
} 

export const ImgFileInput = styled.input`
    display: none;
`;


export const TimeWrapper = styled.div`
    position: absolute;
    top : 0;
    bottom : 0;
    left:0;  
    right: 0; 
    display: flex;

    //font-style 
    z-index: 1000;
`
export const TimeContentWrapper = styled.div`
    position : absolute;
    top:0;
    bottom : 0;
    left:0;
    right:0;
    width : fit-content;
    height: fit-content;
    margin: auto;
    text-align: center;
`;//calc(100vw*(22/375) * 3.84);
export const TimeTop = styled.div`
    font-family : 'Nanum BaReunHiPi';
    font-style: normal;
    font-weight: 400;
    font-size: calc(100vw*(22/375) * 3.84);
    line-height: calc(100vw*(25/375) * 3.84);
    text-shadow: 0px 3.84px 15.36px rgba(28, 28, 28, 0.82);

    color: #FFFFFF;
    // -webkit-text-stroke: 2.5px #FFFFFF; 
`
export const TimeBottom = styled.div`
    font-family: 'Nanum BaReunHiPi';
    font-style: normal;
    font-weight: 400;
    font-size: calc(100vw*(50/375) * 3.84);
    line-height: calc(100vw*(57/375) * 3.84);
    text-shadow: 0px 3.84px 15.36px rgba(28, 28, 28, 0.82);

    color: #FFFFFF;
    // -webkit-text-stroke: 2.5px #FFFFFF; 
`

export const FontSpacer = styled.div`
    display: inline-block;
`